import { getPrivateApi } from "../lib/axiosConfig";
import { EditFleet, Fleet, NewFleet } from "../types/fleets.types";
import { AppError } from "./classes";

const api = getPrivateApi();
const endpoint = "/fleets";

export const getFleets = async (): Promise<Fleet[]> => {
  try {
    const { data } = await api.get(`${endpoint}`);
    return data;
  } catch (error: any) {
    console.error("Erro ao buscar frotas:", error?.response ?? error);
    const message = error?.response?.data?.message ?? "Erro inesperado ao buscar frotas.";
    throw new AppError(message, error.status);
  }
};

export const getFleetsByClient = async (clientId: string): Promise<Fleet[]> => {
  try {
    const { data } = await api.get(`${endpoint}/client/${clientId}`);
    return data;
  } catch (error: any) {
    console.error("Erro ao buscar frotas do cliente:", error?.response ?? error);
    const message = error?.response?.data?.message ?? "Erro inesperado ao buscar frotas.";
    throw new AppError(message, error.status);
  }
};

export const addVehicle = async (newFleet: NewFleet): Promise<Fleet> => {
  try {
    const { data } = await api.post(`${endpoint}`, newFleet);
    return data;
  } catch (error: any) {
    console.error("Erro ao criar frota:", error?.response ?? error);
    const message = error?.response?.data?.message ?? "Erro inesperado ao criar frota.";
    throw new AppError(message, error.status);
  }
};

export const editVehicle = async (fleet: EditFleet): Promise<Fleet> => {
  try {
    const { id, ...body } = fleet;
    const { data } = await api.put(`${endpoint}/${id}`, body);
    return data;
  } catch (error: any) {
    console.error("Erro ao editar frota:", error?.response ?? error);
    const message = error?.response?.data?.message ?? "Erro inesperado ao editar a frota.";
    throw new AppError(message, error.status);
  }
};

export const deleteVehicle = async (fleetId: string): Promise<void> => {
  try {
    await api.delete(`${endpoint}/${fleetId}`);
  } catch (error: any) {
    console.error("Erro ao deletar frota:", error?.response ?? error);
    const message = error?.response?.data?.message ?? "Erro inesperado ao deletar a frota.";
    throw new AppError(message, error.status);
  }
};
